import authAxios from "../common/authAxios";
import encodeQueryParams from "../helpers/encodeQueryData";

class SecretaryService {
  async getEnrolless(queryParams) {
    return await authAxios.get(
      `/secretary/filter?${encodeQueryParams(queryParams)}`
    );
  }

  async downloadContract(data) {
    return await authAxios.post(`/secretary/download-contract`, data, { responseType: "blob" });
  }

  async downloadApplication(data) {
    return await authAxios.post(`/secretary/download-application`, data, {responseType: "blob"})
  }

  async createContract(data) {
    return await authAxios.post(`/secretary/create-contract`, data);
  }

  async convertToStudent(queryParams) {
    return await authAxios.get(
      `/secretary/get-users-for-du?${encodeQueryParams(queryParams)}`
    );
  }

  async getVarcode(){
    return await authAxios.get(`/secretary/get-varcode`);
  }

  // async getEnrolleeById(id) {
  //   return await authAxios.get(`http://localhost:3000/enrollees/${id}`);
  // }

  async postUsersFromCurrentPage(data) {
    const applicationYear = localStorage.getItem("AdmissionOfYear");
    return await authAxios.post(
      `/excel/current-page?application_year=${applicationYear}`,
      data,
      { responseType: "blob" }
    );
  }

  async postUsersThatMatchQuery(data) {
    const applicationYear = localStorage.getItem("AdmissionOfYear");
    return await authAxios.post(
      `/excel/all-pages?application_year=${applicationYear}`,
      data,
      {
        responseType: "blob",
      }
    );
  }
  async getEnrolleeById(id) {
    return await authAxios.get(`/admission-info/get-by-id?user_id=${id}`);
  }
  async sendMessage(newObject) {
    return await authAxios.post(`/secretary/send-message-to-user`, newObject);
  }
  async getEducation(id) {
    return await authAxios.get(`/educational-info/get-by-one?user_id=${id}`);
  }
  async getDocumentById(id) {
    return await authAxios.get(`/documents/get-by-id?user_id=${id}`);
  }
  getAdmission(id) {
    return authAxios.get(`/admission-info/get-by-id?user_id=${id}`);
  }
  async getPersonal(id) {
    return await authAxios.get(`/personal-info/get-by-one?user_id=${id}`);
  }
  async getAbitur(id) {
    return await authAxios.get(`/secretary/get-abitur-info?user_id=${id}`);
  }
  async postAbitur(id, data) {
    return await authAxios.post(
      `/secretary/save-abitur-info?user_id=${id}`,
      data
    );
  }
  async getSocialStatusTypes() {
    return await authAxios.get("/dictionaries/social-status-type");
  }
  async uploadPoints(newObject) {
    return await authAxios.post(`/secretary/mark-exams`, newObject);
  }
  async isApproved(id) {
    return await authAxios.post(`/secretary/confirm-blocks?user_id=${id}`);
  }
  async checkConfirm(id) {
    return await authAxios.get(`/secretary/check-confirm?user_id=${id}`);
  }
  async giveStatusToEnrollee(data) {
    return await authAxios.post("/secretary/abitur-status", data);
  }
  async getEnrolleeStatus(id) {
    return await authAxios.get(`/secretary/abitur-get-status?user_id=${id}`);
  }

  async updateEducationalProgram(educationalProgramId, userId) {
    return await authAxios.put(
      `/secretary/educational-group-update?group_id=${educationalProgramId}&user_id=${userId}`
    );
  }

  async getAbiturStatus(id) {
    return await authAxios.get(`/secretary/abitur-get-status?user_id=${id}`); // 3 - не прошел конкурс
  }

  async getEntStatus(id) {
    return await authAxios.get(
      `/secretary/abitur-dormitory-status?user_id=${id}`
    );
  }

  async getAbiturBarCode(id) {
    return await authAxios.get(`/secretary/get-var-code?user_id=${id}`); // bar code
  }

  changePoints(userId, englishPoint, ictPoint) {
    return authAxios.post(`/admission-info/change-points?userId=${userId}&englishPoint=${englishPoint}&ictPoint=${ictPoint}`);
  }
}

export default SecretaryService;
